module.exports = __webpack_public_path__ + "static/media/quiz-outono.4a992c2a.png";